// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + "styles" + "." + "a3eeb045bb8c7d7a8196" + ".css";
};